import { useAuthStore } from '@/stores/authStore';
import { PERMISSIONS } from './permissionsConstants';
import { ROLE_IDS } from '@/utils/constants';

function resolvePermissionId(permission) {
    return typeof permission === 'number' ? permission : PERMISSIONS[permission];
}

export function userHasPermission(permission) {
    const authStore = useAuthStore();

    if (authStore.isSuperAdmin) {
        return true;
    }

    if (!authStore.permissions || !permission) {
        return false;
    }

    const requiredPermissions = Array.isArray(permission) ? permission : [permission];
    const permissionIds = requiredPermissions.map(resolvePermissionId);

    return permissionIds.every(permissionId =>
        permissionId !== undefined && authStore.hasPermission(permissionId)
    );
}

export function userHasAnyPermission(permissions = []) {

    const requiredPermissions = Array.isArray(permissions) ? permissions : [permissions];

    return requiredPermissions.some(permission => userHasPermission(permission));
}

export function userHasRole(allowedRoles = []) {

    const authStore = useAuthStore();

    if (authStore.isSuperAdmin) {

        return true;

    }

    if (!authStore.role) {

        return false;

    }

    const userRoleName = ROLE_IDS[authStore.role.id];

    return allowedRoles.includes(userRoleName);
}

export function userCanAccess(meta = {}) {

    if (meta.permission) {

        return userHasPermission(meta.permission);

    }

    if (meta.anyPermission) {

        return userHasAnyPermission(meta.anyPermission);

    }

    if (meta.roles) {

        return userHasRole(meta.roles);

    }

    return true;
}